import { Component, Input } from '@angular/core';
import { ZoningCode } from 'src/app/modules/instance/models';
import { JobsService, ZoningCodeService } from 'src/app/modules/instance/services';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { filter, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TaskType } from 'src/app/shared/enums/task-type-enum';

@Component({
    standalone: false,
    selector: 'app-zoning-code-delete-button',
    templateUrl: './zoning-code-delete-button.component.html',
    styleUrls: ['./zoning-code-delete-button.component.scss']
})
export class zoningCodeDeleteButtonComponent {
    constructor(
        private readonly zoningCodeService: ZoningCodeService,
        private readonly dialog: MatDialog,
        private readonly snackBar: MatSnackBar,
        private readonly jobsService: JobsService
    ) {}

    @Input()
    public zoningCode: ZoningCode;

    public deleteZoningCode(event: Event, zoningCode: ZoningCode) {
        this.openDeleteZoningCodeDialog(zoningCode);
        event.stopPropagation();
    }

    public openDeleteZoningCodeDialog(zoningCode: ZoningCode) {
        if (!zoningCode.Id || !zoningCode.Name) {
            return;
        }

        const dialogConfig = new MatDialogConfig();

        const title = 'Remove Zoning Code';
        const topContent = `If you continue, a <b>Remove Zoning Code</b> job will be created and started, removing all calculation results for <b>${zoningCode.Name}</b>.`;

        dialogConfig.autoFocus = true;
        dialogConfig.data = { title, topContent, yesButtonLabel: 'Continue', noButtonLabel: 'Cancel' };
        dialogConfig.maxHeight = '600px';
        dialogConfig.maxWidth = '450px';

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
        dialogRef
            .afterClosed()
            .pipe(
                filter(isConfirm => isConfirm),
                switchMap(() => {
                    const hasTasks: boolean =
                        zoningCode.hasTasks() || zoningCode.Versions.some(zcVersion => zcVersion.hasTasks);

                    if (hasTasks) {
                        this.snackBar.open(
                            `First you must delete all tasks for the selected Zoning Code and relater Versions.`,
                            'OK',
                            {
                                verticalPosition: 'top',
                                horizontalPosition: 'center',
                                duration: 4000
                            }
                        );

                        return of(null);
                    }

                    zoningCode.setDeletionStatus();

                    return this.jobsService.addJob(TaskType.REMOVE_ZONING_CODE_JOB, {
                        name: `${this.zoningCode.Name}`,
                        doNotRun: false,
                        zoningCodeId: this.zoningCode.Id
                    });
                }),
                filter(removalStatistic => !!removalStatistic)
            )
            .subscribe(
                () => {
                    this.zoningCodeService.removeZoningCode(zoningCode.Id);

                    this.snackBar.open(`Zoning Code ${zoningCode.Name} removing Job is in progress`, 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 4000
                    });
                },
                error => {
                    this.snackBar.open(error.error.messages[0], 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 2000
                    });
                }
            );
    }
}
